import * as Sentry from "@sentry/gatsby";

Sentry.init({
  dsn: "https://99d40a492038bf72a4fdba08204db0bb@o37716.ingest.us.sentry.io/4507063304585216",
  integrations: [Sentry.replayIntegration()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});
